import { GEOLOCATION_API } from '@/constants/constants';
import { useState, useEffect } from 'react';

interface GeoLocation {
  country_3: string;
  ip: string;
  country: string;
  name: string;
}

interface UseGeoLocationReturn {
  location: GeoLocation | null;
  loading: boolean;
  error: Error | null;
}

/**
 * Custom hook to fetch the user's geographic location based on their IP
 * @returns Object containing location data, loading state, and any error
 */
function useGeoLocation(): UseGeoLocationReturn {
  const [location, setLocation] = useState<GeoLocation | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        setLoading(true);
        const response = await fetch(GEOLOCATION_API);

        if (!response.ok) {
          throw new Error(`Failed to fetch location: ${response.status}`);
        }

        const data: GeoLocation = await response.json();
        setLocation(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('An unknown error occurred'));
        console.error('Error fetching geo location:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchLocation();
  }, []);

  return { location, loading, error };
}

export default useGeoLocation;
